import React from 'react';

export default ({ className }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
    <g>
      <path
        d="M16,32 C7.163444,32 1.082166e-15,24.836556 0,16 C-1.082166e-15,7.163444 7.163444,1.623249e-15 16,0 C24.836556,-1.623249e-15 32,7.163444 32,16 C32,20.2434638 30.3142906,24.3131264 27.3137085,27.3137085 C24.3131264,30.3142906 20.2434638,32 16,32 Z M16,2 C8.2680135,2 2,8.2680135 2,16 C2,23.7319865 8.2680135,30 16,30 C23.7319865,30 30,23.7319865 30,16 C30,12.2869691 28.5250042,8.72601436 25.8994949,6.10050506 C23.2739856,3.47499577 19.7130309,2 16,2 Z"/>
      <polygon className="euiIcon__fillSecondary" points="23 15 17 15 17 9 15 9 15 15 9 15 9 17 15 17 15 23 17 23 17 17 23 17"/>
    </g>
  </svg>
);
